import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

const NotFoundPublic = () => {
  const navigate = useNavigate();

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '100vh',
      background: '#f0f2f5'
    }}>
      <Result
        status="404"
        title={<span className="notfound-title">Página no encontrada</span>}
        subTitle={
          <span className="notfound-subtitle">
            La página que está intentando acceder no está disponible o es incorrecta.
            <br />
            Por favor consulte al administrador
          </span>
        }
        extra={
          <Button
            type="primary"
            size="large"
            onClick={() => navigate("/login")}
          >
            Ir al inicio de sesión
          </Button>
        }
      />
    </div>
  );
};

export default NotFoundPublic;